import { getConfig as n } from "./td-longtail-vue-components2.js";
const o = () => {
  const { cloudFront: t } = n() || {};
  return !t || !t.imagesEnabled ? "" : t.url ? t.url : t?.host ? `//${t.host}` : "";
}, s = (t) => {
  const r = o();
  return !t || t.startsWith("//") || t.startsWith("http") || !r ? t : r + (t.startsWith("/") ? "" : "/") + t;
};
export {
  s as addCdnHost,
  o as getCdnBaseUrl
};
